var plugin_rtlignore_default = {
  "alignLeft": "L25ty",
  "textWrapNowrap": "YHYJf",
  "alignRight": "dE9hx",
  "alignCenter": "bRMLc",
  "sizeFullWidth": "itlHF",
  "renderedInTable": "PLAob",
  "sizeOriginal": "TXTOv",
  "sizeContent": "E-AYw",
  "sizeSmall": "OQ4MB",
  "sizeSmallCenter": "RtAV9",
  "flex": "NCR6u",
  "atomic": "x0Od4",
  "embed": "Glh3c",
  "horizontalScrollbar": "rMfZ8",
  "pluginContainerMobile": "Xj9ZL"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
